module.exports = __webpack_public_path__ + "static/logo_round_white-e2e939bd1da25207fadf6de31d0f0d22.png";